// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disabled{color:#e0e0e0;cursor:default!important}.disabled:hover{background:none!important}.cv-button{overflow:hidden!important}.cv-button:hover{outline:none!important;box-shadow:none!important;border:none!important}", ""]);
// Exports
module.exports = exports;
